"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CloseButton = void 0;
var _index = require("../ButtonTertiary/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var CloseButton = exports.CloseButton = (0, _styledComponents["default"])(_index.ButtonTertiary).withConfig({
  displayName: "CloseButton",
  componentId: "sc-i2fggp-0"
})(["position:absolute;top:4px;right:4px;[dir='rtl'] &{right:unset;left:4px;}"]);